export const OFFICE_STATUS = {
  APPLIED: "APPLIED",
  DESIGN_MATCHED: "DESIGN_MATCHED",
  ESTIMATE_SELECTED: "ESTIMATE_SELECTED",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  PAYMENT_DONE: "PAYMENT_DONE",
  RNB_PENDING: "RNB_PENDING",
  RNB_APPROVED: "RNB_APPROVED",
  ENGINEER_PENDING: "ENGINEER_PENDING",
  ENGINEER_APPROVED: "ENGINEER_APPROVED",
  CA_PENDING: "CA_PENDING",
  CA_APPROVED: "CA_APPROVED",
  REGISTRAR_PENDING: "REGISTRAR_PENDING",
  REGISTRAR_APPROVED: "REGISTRAR_APPROVED",
  SUBSIDY_RELEASED: "SUBSIDY_RELEASED",
};

export const statusLabels = {
  APPLIED: "Application Submitted",
  DESIGN_MATCHED: "Design Matched",
  ESTIMATE_SELECTED: "Estimate Selected",
  PAYMENT_PENDING: "Payment Pending",
  PAYMENT_DONE: "Payment Done",
  RNB_PENDING: "R&B Verification Pending",
  RNB_APPROVED: "R&B Approved",
  ENGINEER_PENDING: "Engineer Inspection Pending",
  ENGINEER_APPROVED: "Engineer Approved",
  CA_PENDING: "CA Utilization Pending",
  CA_APPROVED: "CA Approved",
  REGISTRAR_PENDING: "Registrar Approval Pending",
  REGISTRAR_APPROVED: "Registrar Approved",
  SUBSIDY_RELEASED: "Subsidy Released",
};